export function discountDurationFilter(input) {

    switch (input) {

        default:
            return `Na ${ input } ${ input === 1 ? "maand" : "maanden" }`;
    }
}